import React from "react";
import { formatDate } from "@/lib/api";

export function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 animate-fade-up">
      <div>
        {eyebrow && (
          <p className="font-mono text-[11px] uppercase tracking-widest text-blue-400 mb-2">{eyebrow}</p>
        )}
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-100">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-slate-400 max-w-2xl">{subtitle}</p>}
      </div>
      {children && <div className="shrink-0">{children}</div>}
    </div>
  );
}

export function AsOfBar({ asOf }) {
  if (!asOf) return null;
  const items = [
    ["Income Tax", formatDate(asOf.income_tax_synced)],
    ["FCRA", formatDate(asOf.fcra_refreshed)],
    ["Darpan", formatDate(asOf.darpan_scraped)],
    ["Mapping run", `#${asOf.mapping_run}`],
  ];
  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-1 rounded-lg border border-slate-800 bg-slate-900 px-4 py-2.5 font-mono text-[11px] text-slate-400">
      <span className="uppercase tracking-widest text-slate-500">As of</span>
      {items.map(([k, v]) => (
        <span key={k} className="flex items-center gap-1.5">
          <span className="text-slate-400">{k}</span>
          <span className="font-semibold text-slate-100">{v}</span>
        </span>
      ))}
    </div>
  );
}
